import styled from "styled-components";
import { theme, typography } from "../styles";

export const TrackSection = styled.section`
  position: relative;
  padding: 64px 16px;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: 96px 24px;
  }
`;

export const TrackBgGradient = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    hsl(32 95% 55% / 0.1) 0%,
    ${theme.bg} 50%,
    hsl(32 80% 45% / 0.05) 100%
  );
`;

export const TrackBgRadial = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  background: radial-gradient(
    ellipse at center,
    hsl(32 95% 55% / 0.15) 0%,
    transparent 70%
  );
`;

export const TrackInner = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  text-align: center;
`;

export const TrackBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  padding: 8px 16px;
  border: 1px solid hsl(32 95% 55% / 0.2);
  border-radius: 999px;
  background: hsl(32 95% 55% / 0.1);
  color: ${theme.primary};
  font-size: 0.875rem;
  font-weight: ${typography.weights.semibold};

  .material-icons {
    font-size: 16px;
  }
`;

export const TrackTitle = styled.h2`
  margin: 0 0 24px;
  color: ${theme.foreground};
  font-size: clamp(2rem, 5vw, 3.75rem);
  font-weight: ${typography.weights.extrabold};
  line-height: 1.12;
  letter-spacing: ${typography.tracking.tighter};

  span {
    background-image: ${theme.gradientGold};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const TrackLead = styled.p`
  margin: 0 auto 48px;
  max-width: 768px;
  color: ${theme.textMuted};
  font-size: clamp(1.0625rem, 2vw, 1.25rem);
  line-height: 1.65;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  max-width: 896px;
  margin: 0 auto;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const StatTile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px;
  border: 1px solid ${theme.borderSoft};
  border-radius: 16px;
  background: hsl(var(--hp-card) / 0.4);
  backdrop-filter: blur(8px);
  text-align: center;
  transition: border-color 0.25s ease, transform 0.25s ease;

  &:hover {
    border-color: hsl(32 95% 55% / 0.4);
    transform: translateY(-2px);
  }
`;

export const StatTileIcon = styled.span`
  display: inline-flex;
  margin-bottom: 16px;
  color: ${theme.primary};

  .material-icons {
    font-size: 32px;
  }
`;

export const StatTileValue = styled.div`
  margin-bottom: 8px;
  color: ${theme.foreground};
  font-size: 2.25rem;
  font-weight: ${typography.weights.extrabold};
  line-height: 1;

  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const StatTileLabel = styled.div`
  color: ${theme.textMuted};
  font-size: 0.875rem;
  font-weight: ${typography.weights.semibold};
  letter-spacing: ${typography.tracking.wide};
  text-transform: uppercase;
`;
